import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { from, mergeMap } from 'rxjs';
import { ImageUploadOfflineService } from '../../_services/image-upload-offline.service';
import { ImageUploadService } from '../../_services/image-upload.service';
import { extractFilesFromSystemEntries } from '../../_services/image-upload/file-system-entries-extract.service';
import { NetworkStatusService } from '../../_services/network-status.service';
import { InspectionImageStateService } from '../inspection-images-state.service';

@Directive({
    selector: '[appUploadInspectionFiles]',
    standalone: false
})
export class UploadInspectionFilesDirective {
  @Input() locationId: string | null = null;
  @Input() inspectionId: string | null = null;
  @Input() uploadDisabled = false;

  constructor(private el: ElementRef,
    private imageUploadOnlineService: ImageUploadService,
    private imageUploadOfflineService: ImageUploadOfflineService,
    private networkStatusService: NetworkStatusService,
    private inspectionImageStateService: InspectionImageStateService

  ) { }

  @HostListener('dragleave', ['$event']) onDragLeave(event: DragEvent) {
    if (this.uploadDisabled) {
      return;
    }
    this.removeDragOverClass();
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent): void {
    if (this.uploadDisabled) {
      return;
    }
    this.addDragOverClass();
    event.stopPropagation();
    event.preventDefault();
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent): void {
    if (this.uploadDisabled) {
      return;
    }
    this.onDrop4Upload(event);
    this.removeDragOverClass();
  }

  async onDrop4Upload(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();

    if (event.dataTransfer.items.length == 0) {
      return;
    }

    if (this.isOffline) {
      return this.imageUploadOfflineService
        .uploadFiles(this.inspectionId, this.locationId, event.dataTransfer.items)
        .subscribe(_ => { this.inspectionImageStateService.fetchAndUpdate(this.inspectionId); });
    }

    from(this.extractFiles(event.dataTransfer.items))
      .pipe(mergeMap(files => this.imageUploadOnlineService.uploadInspectionFiles(this.inspectionId, this.locationId, files)))
      .subscribe();

  }

  private extractFiles(dtItemList: DataTransferItemList) {
    const items: FileSystemEntry[] = [];
    for (let i = 0; i < dtItemList.length; i++) {
      items.push(dtItemList[i].webkitGetAsEntry());
    }
    return extractFilesFromSystemEntries(items, []);
  }

  get isOffline() {
    return this.networkStatusService.isOffline;
  }

  private removeDragOverClass() {
    const parentDiv = this.el.nativeElement.parentNode;
    parentDiv.classList.remove('drag-over');
  }

  private addDragOverClass() {
    const parentDiv = this.el.nativeElement.parentNode;
    parentDiv.classList.add('drag-over');
  }

}
